function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useCallback as T, useRef as d } from "react";
import { FocusableMode as y, isFocusableElement as M } from '../utils/focus-management.js';
import { isMobile as g } from '../utils/platform.js';
import { useDocumentEvent as c } from './use-document-event.js';
import { useIsTopLayer as L } from './use-is-top-layer.js';
import { useLatestValue as b } from './use-latest-value.js';
import { useWindowEvent as P } from './use-window-event.js';
var E = 30;

function R(p, f, C) {
  var u = L(p, "outside-click"),
      m = b(C),
      s = T(function (e, n) {
    if (e.defaultPrevented) return;
    var r = n(e);
    if (r === null || !r.getRootNode().contains(r) || !r.isConnected) return;

    var h = function l(o) {
      return typeof o == "function" ? l(o()) : Array.isArray(o) || o instanceof Set ? o : [o];
    }(f);

    var _iterator = _createForOfIteratorHelper(h),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var l = _step.value;
        if (l !== null && (l.contains(r) || e.composed && e.composedPath().includes(l))) return;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return !M(r, y.Loose) && r.tabIndex !== -1 && e.preventDefault(), m.current(e, r);
  }, [m, f]),
      i = d(null);
  c(u, "pointerdown", function (t) {
    var e, n;
    i.current = ((n = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : n[0]) || t.target;
  }, !0), c(u, "mousedown", function (t) {
    var e, n;
    i.current = ((n = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : n[0]) || t.target;
  }, !0), c(u, "click", function (t) {
    g() || i.current && (s(t, function () {
      return i.current;
    }), i.current = null);
  }, !0);
  var a = d({
    x: 0,
    y: 0
  });
  c(u, "touchstart", function (t) {
    a.current.x = t.touches[0].clientX, a.current.y = t.touches[0].clientY;
  }, !0), c(u, "touchend", function (t) {
    var e = {
      x: t.changedTouches[0].clientX,
      y: t.changedTouches[0].clientY
    };
    if (!(Math.abs(e.x - a.current.x) >= E || Math.abs(e.y - a.current.y) >= E)) return s(t, function () {
      return t.target instanceof HTMLElement ? t.target : null;
    });
  }, !0), P(u, "blur", function (t) {
    return s(t, function () {
      return window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null;
    });
  }, !0);
}

export { R as useOutsideClick };